import { createBrowserRouter } from 'react-router-dom'
import MainLayout from './layout/MainLayout'
import FilesPage from './pages/FilesPage'
import FilePage from './pages/FilePage'
import DataMatchPage from './pages/DataMatchPage'
import RouteErrorBoundary from './components/RouteErrorBoundary'
import { UnsubscribedPage } from './components/UnauthPages/UnsubscribedPage'
import { subscriptionStatusLoader } from './loader'
import AuthenticationPage from './pages/AuthenticationPage'
import AuthenticationLayout from './layout/AuthenticationLayout'

const router = createBrowserRouter([
  {
    path: 'auth',
    Component: AuthenticationLayout,
    ErrorBoundary: RouteErrorBoundary,
    children: [
      {
        index: true,
        Component: AuthenticationPage,
      },
      {
        path: '*',
        Component: AuthenticationPage,
      },
    ],
  },
  {
    path: 'unsubscribed',
    Component: UnsubscribedPage,
    ErrorBoundary: RouteErrorBoundary,
  },
  {
    path: '/',
    Component: MainLayout,
    children: [
      {
        index: true,
        Component: FilesPage,
      },
      {
        path: 'file/:id',
        Component: FilePage,
      },
      {
        path: 'data-match',
        Component: DataMatchPage,
      },
      { path: '*', Component: FilesPage },
    ],
    ErrorBoundary: RouteErrorBoundary,
    loader: subscriptionStatusLoader,
  },
])

export default router
